import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CreateRestaurantForm from "./CreateRestaurantForm";
import "./Restaurants.css";

export default function RestaurantsPage() {
  const [restaurants, setRestaurants] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchRestaurants();
    // eslint-disable-next-line
  }, []);

  const fetchRestaurants = async () => {
    setError("");
    try {
      const token = localStorage.getItem("access_token");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/restaurants`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!res.ok) {
        throw new Error("Errore durante il caricamento dei ristoranti");
      }
      const data = await res.json();
      setRestaurants(data);
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  };

  const handleRestaurantCreated = (newRestaurant) => {
    // Aggiunge in cima l’ultimo creato
    setRestaurants((prev) => [newRestaurant, ...prev]);
  };

  const handleSelectRestaurant = (restaurant) => {
    // Naviga alla pagina di dettaglio, es. /admin/restaurants/1
    navigate(`/admin/restaurants/${restaurant.id}`);
  };

  return (
    <div className="restaurants-page-container">
      <h1 className="page-title">Ristoranti</h1>

      {/* Se c'è un errore di fetch, lo mostriamo */}
      {error && <p className="error-text">{error}</p>}

      {/* Form di creazione in alto */}
      <div className="create-restaurant-block">
        <h2>Crea nuovo Ristorante</h2>
        <CreateRestaurantForm onRestaurantCreated={handleRestaurantCreated} />
      </div>

      {/* Griglia di card per i ristoranti */}
      <div className="restaurant-cards-grid">
        {restaurants.length === 0 ? (
          <p className="no-restaurants-text">Nessun ristorante trovato.</p>
        ) : (
          restaurants.map((rest) => (
            <div
              key={rest.id}
              className="restaurant-card"
              onClick={() => handleSelectRestaurant(rest)}
            >
              <h3 className="restaurant-card-title">{rest.name}</h3>
              {/* Se vuoi aggiungere altre info, puoi inserirle qui */}
              <p className="restaurant-card-meta">
                {/* Esempio: ID e/o company_id, se servono */}
                ID: {rest.id}
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
